export const destroyUserSession = async () => {
	return await fetch(`${process.env.NEXT_PUBLIC_API_URL}/user/sessions`, {
		method: 'DELETE',
		credentials: 'include',
	});
};
